// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608310653/js/" + chunkId + "." + {"44":"4c045d1a","225":"e6326605","481":"b784d2f4","486":"c28d02a1","770":"2c3dcb4e"}[chunkId] + ".0.507442963762609.chunk.js";
};